// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@pace/XDL/types";

export default {
    primary: {
        main: "#001F60",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#0073B2",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#97A3AE",
        disabled: "#E7EBEF",
        // XNG-Changes
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#96CCE9",
        ui9: "#6BBBE7",
        ui10: "#FF9E18",
        ui11: "#E7EBEF",
        ui12: "#97A3AE",
        ui13: "#758592",
        ui14: "#415364",
        ui15: "#FFCC85",
        ui16: "#C87B11",
        ui17: "#9DAAB6",
        ui18: "#1B2D3E",
        ui19: "#00133c",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#000000",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#0073B2",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#FF9E18",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#0073B2",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
